// PreviewImageModal.js
import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";

import './PreviewImageModal.css';

export default function PreviewImageModal({ open, src, toggle }) {
  return (
    <Modal 
      isOpen={open} 
      toggle={toggle} 
      centered 
      size="lg" 
      backdrop="static"
      contentClassName="preview-modal-content"
    >
      <ModalBody className="p-0 d-flex justify-content-center">
        {/* keep it inside viewport without distorting ratio */}
        <img
          src={src}
          alt="preview"
          style={{ maxWidth: "90vw", maxHeight: "90vh" }}
          onClick={toggle}    // click anywhere to close
        />
      </ModalBody>
    </Modal>
  );
}
